import { observable, action } from 'mobx';
import { SnackbarState } from './index';

export const snackbarState = observable<SnackbarState>({
  isOpen: false,
  message: '',
  autoHideDuration: 6000,
});

export const showErrorSnackbar = action((message: string, autoHideDuration = 6000) => {
  snackbarState.isOpen = true;
  snackbarState.message = message;
  snackbarState.autoHideDuration = autoHideDuration;
});

export const hideSnackbar = action(() => {
  snackbarState.isOpen = false;
  snackbarState.message = '';
});
